import React, { useState } from "react";
import { Field } from "formik";
import { get } from "lodash";
import { useDispatch } from "react-redux";

import Actions from "modules/entity/actions";
import UiComponents from "../index";

import { ReactComponent as AddIcon } from "assets/images/icons/plus.svg?react";
import { helpers } from "services";

const CreatableField = ({
    size,
    selectName = '',
    selectLabel = '',
    selectPlaceholder = '',
    selectClassName = '',
    selectValues,
    loadOptionsUrl,
    optionValue = null,
    optionLabel = null,
    loadOptionsParams,
    isSearchable,
    isClearable,
    isMulti,
    disableOptions = [],
    onChangeHandler = () => { },
    createCb = () => { },
    canUpdate,

    inputName,
    inputLabel,
    inputPlaceholder,
    createOptionLabel,
    createUrl = "",
    createValues,
    inputClassName = '',

    values,
    setFieldValue,
    isDisabled = false,

}) => {
    const dispatch = useDispatch();

    const [visibleCreate, setVisibleCreate] = useState(false);

    const openSelect = () => {
        setVisibleCreate(false);
        if (get(values, `${selectName}.id`) === 0) {
            setFieldValue(selectName, null);
            setFieldValue(inputName, "");
        }
    };

    const createAction = value => {
        dispatch(Actions.FormDefault.request({
            method: "post",
            url: createUrl,
            values: createValues(value),
            cb: {
                success: data => {
                    if (isMulti) {
                        setFieldValue(selectName, [...selectValues, data]);
                        setFieldValue(inputName, "");
                        setVisibleCreate(false);
                    } else {
                        setFieldValue(selectName, data);
                        setFieldValue(inputName, "");
                        setVisibleCreate(false);
                    }
                    createCb(data)
                },
                error: (error) => {
                },
                finally: () => {
                }
            }
        }));
    };

    const handleKeyPress = event => {
        const value = event.target.value;
        if (event.key === "Enter" && value) {
            event.preventDefault();
            if (!helpers.validateIsEmpty(value)) {
                createAction(value);
            }
        }
    };

    return (
        <>
            {visibleCreate ? (
                <Field
                    component={UiComponents.InputS1}
                    size={size}
                    name={inputName}
                    label={inputLabel}
                    placeholder={inputPlaceholder}
                    autoFocus={true}
                    onBlur={() => openSelect()}
                    onKeyPress={handleKeyPress}
                    disabled={isDisabled}
                    className={inputClassName}
                    validate={helpers.validateIsEmpty}
                />
            ) :
                <Field
                    component={UiComponents.AsyncSelectS1}
                    size={size}
                    name={selectName}
                    label={selectLabel}
                    placeholder={selectPlaceholder}
                    loadOptionsUrl={loadOptionsUrl}
                    optionValue={optionValue}
                    optionLabel={optionLabel}
                    isSearchable={isSearchable}
                    isClearable={isClearable}
                    isDisabled={isDisabled}
                    canUpdate={canUpdate}
                    className={selectClassName}
                    isMulti={isMulti}
                    disableOptions={disableOptions}
                    // handleChange={option => {
                    //     if (Array.isArray(option)) {
                    //         const hasCreate = option.find(o => o.id === 0);
                    //         if (hasCreate) {
                    //             setVisibleCreate(true);
                    //             setFieldValue(selectName, option.filter(o => o.id !== 0));
                    //         }
                    //     } else if (option && option[optionValue] === 0) {
                    //         setVisibleCreate(true);
                    //         setFieldValue(selectName, null);
                    //     }
                    //     onChangeHandler(option)
                    // }}
                    // handleChange={option => {
                    //     let cleanOption = option;

                    //     if (Array.isArray(option)) {
                    //         const hasCreate = option.find(o => o.id === 0);

                    //         if (hasCreate) {
                    //             setVisibleCreate(true);
                    //             cleanOption = option.filter(o => o.id !== 0);
                    //             setFieldValue(selectName, cleanOption);
                    //         }
                    //     } else if (option && option[optionValue] === 0) {
                    //         setVisibleCreate(true);
                    //         cleanOption = null;
                    //         setFieldValue(selectName, null);
                    //     }

                    //     onChangeHandler(cleanOption);
                    // }}
                    handleChange={async option => {
                        let clean = option;

                        if (Array.isArray(option)) {
                            const hasCreate = option.find(o => o.id === 0);
                            if (hasCreate) {
                                setVisibleCreate(true);
                                clean = option.filter(o => o.id !== 0);

                                await setFieldValue(selectName, clean);
                            }
                        } else if (option && option[optionValue] === 0) {
                            setVisibleCreate(true);

                            clean = null;
                            await setFieldValue(selectName, null);
                        }

                        onChangeHandler(clean);
                    }}

                    loadOptionsKey={data => {
                        return get(data, "current_page") === 1 ? [
                            {
                                [optionValue]: 0,
                                [optionLabel]: (
                                    <div className="select_add_option">
                                        <AddIcon />
                                        <span>{createOptionLabel}</span>
                                    </div>
                                )
                            },
                            ...get(data, "data", [])
                        ] : [...get(data, "data", [])];
                    }}
                    loadOptionsParams={loadOptionsParams}
                />
            }
        </>
    );
};

export default CreatableField;
